import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getCampaigns } from '../api/campaigns';
import type { GetCampaignsParams } from '../types';

export function useCampaigns(params: GetCampaignsParams = {}) {
  return useQuery({
    queryKey: ['campaigns', params],
    queryFn: () => getCampaigns(params),
    ...listQueryDefaults,
  });
}
